"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OTAFirmwareUpdateT = exports.OTAFirmwareUpdate = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const device_id_js_1 = require("../../solarxr-protocol/datatypes/device-id.js");
const firmware_part_js_1 = require("../../solarxr-protocol/rpc/firmware-part.js");
class OTAFirmwareUpdate {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsOTAFirmwareUpdate(bb, obj) {
        return (obj || new OTAFirmwareUpdate()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsOTAFirmwareUpdate(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new OTAFirmwareUpdate()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    /**
     * id of the device, this refer to the actual DeviceId from the protocol
     */
    deviceId(obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new device_id_js_1.DeviceId()).__init(this.bb_pos + offset, this.bb) : null;
    }
    /**
     * A table containing the url and offset of the firmware bin file
     */
    firmwarePart(obj) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? (obj || new firmware_part_js_1.FirmwarePart()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    static startOTAFirmwareUpdate(builder) {
        builder.startObject(2);
    }
    static addDeviceId(builder, deviceIdOffset) {
        builder.addFieldStruct(0, deviceIdOffset, 0);
    }
    static addFirmwarePart(builder, firmwarePartOffset) {
        builder.addFieldOffset(1, firmwarePartOffset, 0);
    }
    static endOTAFirmwareUpdate(builder) {
        const offset = builder.endObject();
        return offset;
    }
    unpack() {
        return new OTAFirmwareUpdateT((this.deviceId() !== null ? this.deviceId().unpack() : null), (this.firmwarePart() !== null ? this.firmwarePart().unpack() : null));
    }
    unpackTo(_o) {
        _o.deviceId = (this.deviceId() !== null ? this.deviceId().unpack() : null);
        _o.firmwarePart = (this.firmwarePart() !== null ? this.firmwarePart().unpack() : null);
    }
}
exports.OTAFirmwareUpdate = OTAFirmwareUpdate;
class OTAFirmwareUpdateT {
    constructor(deviceId = null, firmwarePart = null) {
        this.deviceId = deviceId;
        this.firmwarePart = firmwarePart;
    }
    pack(builder) {
        const firmwarePart = (this.firmwarePart !== null ? this.firmwarePart.pack(builder) : 0);
        OTAFirmwareUpdate.startOTAFirmwareUpdate(builder);
        OTAFirmwareUpdate.addDeviceId(builder, (this.deviceId !== null ? this.deviceId.pack(builder) : 0));
        OTAFirmwareUpdate.addFirmwarePart(builder, firmwarePart);
        return OTAFirmwareUpdate.endOTAFirmwareUpdate(builder);
    }
}
exports.OTAFirmwareUpdateT = OTAFirmwareUpdateT;
